<script setup>
import { ref } from 'vue'
import { ChevronLeftIcon, EnvelopeIcon, WrenchScrewdriverIcon } from '@heroicons/vue/24/outline'
import InquiryDemandForm from '@/components/InquiryDemandForm.vue'
import OrderDemandForm from '@/components/OrderDemandForm.vue'

defineProps({
    services: {
        type: Array,
        required: true,
    },
})

const selectedForm = ref(null)

const formOptions = [
    {
        id: 'contact',
        name: 'Poptávkový formulář',
        description: 'Máte dotaz nebo potřebujete poradit? Napište nám.',
        icon: EnvelopeIcon,
    },
    {
        id: 'service',
        name: 'Objednávkový formulář',
        description: 'Potřebujete servis, opravu nebo instalaci? Vyplňte formulář.',
        icon: WrenchScrewdriverIcon,
    },
]

function selectForm(formId) {
    selectedForm.value = formId
}

function goBack() {
    selectedForm.value = null
}
</script>

<template>
    <div>
        <transition
            enter-active-class="transition ease-out duration-300"
            enter-from-class="opacity-0 translate-y-4"
            enter-to-class="opacity-100 translate-y-0"
            leave-active-class="transition ease-in duration-200"
            leave-from-class="opacity-100 translate-y-0"
            leave-to-class="opacity-0 -translate-y-4"
            mode="out-in"
        >
            <div
                v-if="!selectedForm"
                key="selector"
            >
                <div class="mx-auto max-w-2xl">
                    <h3 class="mb-6 text-center text-lg font-semibold text-gray-900">Vyberte typ formuláře</h3>

                    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
                        <button
                            v-for="option in formOptions"
                            :key="option.id"
                            type="button"
                            class="group relative flex flex-col justify-between space-y-5 overflow-hidden rounded-4xl bg-gray-50 p-2 ring-1 ring-gray-200 transition-all hover:bg-white hover:shadow-xl hover:ring-gray-200"
                            @click="selectForm(option.id)"
                        >
                            <div class="p-4">
                                <div
                                    class="bg-brand-primary/10 text-brand-primary mb-4 inline-flex size-12 items-center justify-center rounded-xl"
                                >
                                    <component
                                        :is="option.icon"
                                        class="size-8"
                                    />
                                </div>
                            </div>

                            <div class="px-2">
                                <p class="mt-1 text-sm text-gray-500">{{ option.description }}</p>
                            </div>

                            <p class="primary-link inline-flex w-full items-center justify-center rounded-full text-lg">
                                {{ option.name }}
                            </p>
                        </button>
                    </div>
                </div>
            </div>

            <div
                v-else-if="selectedForm === 'contact'"
                key="contact"
                class="flex w-full flex-col items-center"
            >
                <button
                    type="button"
                    class="hover:text-brand-primary mb-6 inline-flex items-center rounded-xl border border-sky-100 bg-white px-4 py-2 text-sm font-medium text-gray-500 transition-colors"
                    @click="goBack"
                >
                    <ChevronLeftIcon class="mr-2 size-4" />
                    Zpět na výběr
                </button>

                <InquiryDemandForm :services="services" />
            </div>

            <div
                v-else-if="selectedForm === 'service'"
                key="service"
                class="flex w-full flex-col items-center"
            >
                <button
                    type="button"
                    class="hover:text-brand-primary mb-6 inline-flex items-center rounded-xl border border-sky-100 bg-white px-4 py-2 text-sm font-medium text-gray-500 transition-colors"
                    @click="goBack"
                >
                    <ChevronLeftIcon class="mr-2 size-4" />
                    Zpět na výběr
                </button>

                <OrderDemandForm />
            </div>
        </transition>
    </div>
</template>
